import { DOAbnormalOperationUserBean } from "./do-abnormal-operation-user-bean";

export class DOAbnormalItemFilesRequest extends DOAbnormalOperationUserBean {
  docIds: string[];


  constructor() {
    super();
    this.docIds=[];

 }
}
